import { render, staticRenderFns } from "./CustomersTag.vue?vue&type=template&id=304a473b&scoped=true"
import script from "./CustomersTag.vue?vue&type=script&lang=js"
export * from "./CustomersTag.vue?vue&type=script&lang=js"
import style0 from "./CustomersTag.vue?vue&type=style&index=0&id=304a473b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a473b",
  null
  
)

export default component.exports